import { createSlice } from '@reduxjs/toolkit'

export const teamPeopleSlice = createSlice({
  name: 'teamPeople',
  initialState: {},
  reducers: {}
})

export const reducer = teamPeopleSlice.reducer
